export default "__VITE_ASSET__BTIMSfNh__"